import { useState, useEffect } from "react";

export const useMobileDetector = () => {
  const [isMobile, setIsMobile] = useState(
    window.matchMedia("(max-width: 500px)").matches,
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.matchMedia("(max-width: 500px)").matches);
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("load", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("load", handleResize);
    };
  }, []);

  return {
    isMobile,
  };
};
